import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

interface QuizProgressProps {
  /** Current question index (0-based) */
  currentIndex: number;
  /** Total number of questions */
  totalQuestions: number;
  /** Number of answered questions */
  answeredCount: number;
}

/**
 * Quiz Progress Component
 * Shows current question number and progress bar
 */
export const QuizProgress = ({ currentIndex, totalQuestions, answeredCount }: QuizProgressProps) => {
  const progress = (answeredCount / totalQuestions) * 100;

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Question {currentIndex + 1} of {totalQuestions}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {answeredCount} answered
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
          },
        }}
      />
    </Box>
  );
};
